import clsx from "clsx";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import useVideoContext from "../../../hooks/useVideoContext/useVideoContext";
import { Steps, useAppState } from "../../../state";
import { SendCCard, RecordVisit } from "../../../data/ClientData";
import ThankYouView from "../../Screens/ThankYouView";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      maxWidth: "100px",
      //background: theme.brand,
      color: "#666",
      "&:hover": {
        background: "orange",
        color: "white"
      }
    }
  })
);

export default function EndCallButton(props: { className?: string }) {
  const classes = useStyles();
  const { room } = useVideoContext();
  const history = useHistory();
  const {
    customerDCXId,
    customerPhone,
    currentStep,
    setCurrentStep
  } = useAppState();

  let params = new URLSearchParams(document.location.search);
  const clientID = params.get("ClientID") + "";
  const locationID = params.get("LocationID") + "";
  const demoNumber = params.get("demo");
  const endContact = () => {
    room!.disconnect();
    // const storedDcxClient = JSON.parse(
    //   localStorage.getItem("DCXCLIENT") as string
    // );
    RecordVisit(clientID, locationID, customerDCXId);
    SendCCard(clientID, locationID, customerDCXId, customerPhone)
      .then(() => {
        // Set the thank you step BEFORE navigation to prevent landing page flash
        setCurrentStep(Steps.thankYouView);
        // Use React Router to navigate without full page reload
        let targetUrl = `/?ClientID=${encodeURIComponent(
          clientID
        )}&LocationID=${encodeURIComponent(locationID)}&ThankYou=true`;
        if (demoNumber) {
          targetUrl += `&demo=${encodeURIComponent(demoNumber)}`;
        }
        history.push(targetUrl);
      })
      .catch(error => {
        console.error("Promise rejected:", error);
      });
  };
  return (
    <Button
      variant="outlined"
      color="primary"
      onClick={endContact}
      className={clsx(classes.button, props.className)}
      data-cy-disconnect
    >
      {currentStep === Steps.videoLobby ? "End Call" : "End Chat"}
    </Button>
  );
}
